import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: /*#__PURE__*/_normalizeClass(`overflow-hidden object-contain object-center flex justify-center items-center`)
}
const _hoisted_2 = ["src"]

import { ImageInfo } from "@/ImageInfo";

import { withDefaults} from "vue"

interface SquareImageProps {
  image?: ImageInfo;
  size?: number;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    image: null,
    size: { default: 40 }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      class: _normalizeClass(`w-${__props.size} h-${__props.size} rounded object-cover object-center hover:opacity-80`),
      src: __props.image?.url
    }, null, 10, _hoisted_2)
  ]))
}
}

})